module.exports = __webpack_public_path__ + "img/layer2.00199574.png";